<template>
    <div class="text-center my-12">
      <h2 class="text-3xl font-bold">Discover Our Best Deals</h2>
      <p class="text-gray-600">Explore our best deals from all over the cities</p>
      <div class="flex justify-center mt-8 space-x-4">
        <div
          v-for="city in cities"
          :key="city.name"
          class="relative w-64 rounded-lg overflow-hidden shadow-lg transform transition-transform duration-300 hover:scale-105"
        >
          <img :src="city.image" alt="City" class="w-full h-48 object-cover" />
          <div class="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end p-4 transition-opacity duration-300 hover:bg-opacity-60">
            <span class="bg-primary text-white text-xs font-bold px-2 py-1 rounded-full absolute top-2 left-2">{{ city.tag }}</span>
            <p class="text-white">{{ city.properties }} Properties</p>
            <h3 class="text-xl font-bold text-white">{{ city.name }}</h3>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        cities: [
          { name: 'Jakarta', properties: 10, image: '/assets/images/jakarta.jpg', tag: 'SALE' },
          { name: 'Bali', properties: 10, image: '/assets/images/bali.jpg', tag: 'MOST POPULAR' },
          { name: 'Surabaya', properties: 10, image: '/assets/images/surabaya.jpg', tag: 'SALE' },
          { name: 'Bogor', properties: 10, image: '/assets/images/bogor.jpg', tag: 'SALE' },
          { name: 'Bogor', properties: 10, image: '/assets/images/bogor.jpg', tag: 'SALE' },
        ],
      };
    },
  };
  </script>
